import { useTranslation } from 'react-i18next'

import { PackageIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const NewRequestedProducts = ({ productsCount }) => {
  const { t } = useTranslation()

  if (!productsCount) return null

  return (
    <Styles.Container>
      <PackageIcon size={24} />
      <Text type="bodyMRegular">
        {productsCount} {productsCount === 1 ? t('Nuevo producto solicitado') : t('Nuevos productos solicitados')}
      </Text>
    </Styles.Container>
  )
}

export default NewRequestedProducts
